module.exports = __webpack_public_path__ + "static/media/spis-dzialow-i-tematow-informatyka-3.00031d95.pdf";